import { TbHeartSearch } from "react-icons/tb";
import { RxDashboard } from "react-icons/rx";
import { LuFolderHeart } from "react-icons/lu";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { RiSettings5Line } from "react-icons/ri";
import {
  FaBullhorn,
  FaChartBar,
  FaComments,
  FaProjectDiagram,
  FaUsers,
} from "react-icons/fa";

const adminPrimary = [
  { to: "/admin/dashboard", label: "Dashboard", icon: RxDashboard, end: true },
  { to: "/admin/projects", label: "Projects", icon: FaProjectDiagram },
  { to: "/admin/students", label: "People", icon: FaUsers },
  { to: "/admin/reports", label: "Reports", icon: FaChartBar },
  { to: "/admin/announcements", label: "Announcements", icon: FaBullhorn },
  { to: "/messages", label: "Messages", icon: FaComments },
];

const studentPrimary = [
  { to: "/dashboard", label: "Dashboard", icon: RxDashboard, end: true },
  { to: "/myprojects", label: "My projects", icon: LuFolderHeart },
  { to: "/browse", label: "Browse projects", icon: TbHeartSearch },
  { to: "/announcements", label: "Announcements", icon: FaBullhorn },
  { to: "/messages", label: "Messages", icon: FaComments },
];

const organizationPrimary = [
  { to: "/dashboard", label: "Dashboard", icon: RxDashboard, end: true },
  { to: "/myprojects", label: "Our projects", icon: LuFolderHeart },
  { to: "/browse", label: "Browse projects", icon: TbHeartSearch },
  { to: "/organization/reports", label: "Reports", icon: FaChartBar },
  { to: "/announcements", label: "Announcements", icon: FaBullhorn },
  { to: "/messages", label: "Messages", icon: FaComments },
];

const secondary = [
  { to: "/settings", label: "Settings", icon: RiSettings5Line },
  { to: "/help", label: "Help", icon: IoMdHelpCircleOutline },
];

const PRIMARY_BY_ROLE = {
  admin: adminPrimary,
  organization: organizationPrimary,
};

export const getNavigation = (role) => ({
  home: role === "admin" ? "/admin/dashboard" : "/dashboard",
  primary: PRIMARY_BY_ROLE[role] || studentPrimary,
  secondary,
});
